import React, { useState } from 'react';
import {
  Button,
  CircularProgress,
  Tooltip,
} from '@mui/material';

import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

import { downloadOrderWaybill } from '../../services/waybillService';

export default function WaybillButton({
  orderId,
  onSuccess,
  onError,
  size = 'small',
  variant = 'outlined',
  fullWidth = false,
  disabled = false,
  sx = {},
}) {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async (event) => {
    /*
     * Prevent a parent table row click handler from opening another page
     * when the Waybill button is clicked.
     */
    event?.stopPropagation();

    if (downloading || disabled) {
      return;
    }

    try {
      setDownloading(true);

      if (typeof onError === 'function') {
        onError('');
      }

      if (typeof onSuccess === 'function') {
        onSuccess('');
      }

      await downloadOrderWaybill(orderId);

      if (typeof onSuccess === 'function') {
        onSuccess(`Waybill downloaded for order #${orderId}.`);
      }
    } catch (error) {
      if (typeof onError === 'function') {
        onError(error.message || 'Failed to download waybill');
      }
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Tooltip
      title={
        downloading
          ? 'Preparing waybill PDF'
          : 'Download waybill PDF'
      }
    >
      <span>
        <Button
          type="button"
          size={size}
          variant={variant}
          fullWidth={fullWidth}
          onClick={handleDownload}
          disabled={disabled || downloading}
          startIcon={
            downloading ? (
              <CircularProgress
                size={16}
                thickness={5}
                color="inherit"
              />
            ) : (
              <PictureAsPdfOutlinedIcon />
            )
          }
          aria-label={`Download waybill for order ${orderId}`}
          sx={{
            borderRadius: 3,
            fontWeight: 900,
            textTransform: 'none',
            whiteSpace: 'nowrap',
            ...sx,
          }}
        >
          {downloading ? 'Downloading...' : 'Waybill'}
        </Button>
      </span>
    </Tooltip>
  );
}